export default __webpack_public_path__ + "static/media/reference-files-light.72ac287b.svg";